module.exports = {
      id: "crime-usage",
      viewBox: "0 0 69.07 72.614",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#crime",
      toString: function () {
        return this.url;
      }
    }